import React from 'react';
import { useLazyQuery } from "@soap/modules";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { Button } from "../../ui/button";
import { ExternalLink } from "lucide-react";
import { useFormatDisplayDate } from "../../../utils/useFormatDisplayDate";

export function InvoicesCard() {
  const formatDate = useFormatDisplayDate();
  const [getProfile, e138GotProfile] = useLazyQuery("C166v1_GetUserProfile", {
    C166_IncludeInvoices: true
  });

  const invoices = e138GotProfile?.e138_Invoices || [];

  const getStatusBadge = (status: string) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower.includes('paid')) {
      return <span className="px-2 py-1 text-xs font-medium rounded-full bg-confirm-action/15 text-confirm-action-dark">Paid</span>;
    } else if (statusLower.includes('pending')) {
      return <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">Pending</span>;
    } else if (statusLower.includes('failed') || statusLower.includes('error')) {
      return <span className="px-2 py-1 text-xs font-medium rounded-full bg-destructive-action/15 text-destructive-action-dark">Failed</span>;
    }
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">{status || 'Unknown'}</span>;
  };

  return (
    <div className="space-y-4">
      {invoices.length > 0 ? (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Action</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {invoices.map((invoice: any, index: number) => (
                <TableRow key={invoice.e138_InvoiceTitle || index}>
                  <TableCell className="font-medium">
                    {formatDate(invoice.e138_Date)}
                  </TableCell>
                  <TableCell>
                    {getStatusBadge(invoice.e138_Status)}
                  </TableCell>
                  <TableCell className="text-right">
                    {invoice.e138_PdfUrl ? (
                      <Button 
                        variant="ghost" 
                        size="sm"
                        asChild
                      >
                        <a 
                          href={invoice.e138_PdfUrl} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="flex items-center gap-1"
                        >
                          Download PDF
                          <ExternalLink className="w-3 h-3" />
                        </a>
                      </Button>
                    ) : (
                      <span className="text-sm text-gray-500">Unavailable</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          No invoices found.
        </div>
      )}
    </div>
  );
}

